import { persisted, log } from "react-svelte-stores";

// is this the first time the user has visited PodSoda on this browser?
export const firstTime = persisted(true, "firstTime");

log("firstTime", firstTime);
